import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, MapIcon, DumbbellIcon, BatteryWarningIcon, SmartphoneIcon, CalendarXIcon, TrendingDownIcon, AlertTriangleIcon } from 'lucide-react';
const painPoints = [{
  title: 'Llegás sin saber qué hacer',
  desc: 'Sin saber qué rutina o progresión hacer hoy para acercarte a HYROX.',
  icon: MapIcon
}, {
  title: 'Arrancás y abandonás',
  desc: 'Empezás con energía pero a la segunda semana la rutina se cae sola.',
  icon: XCircleIcon
}, {
  title: 'No sabés por dónde empezar',
  desc: 'HYROX parece enorme y no tenés un mapa claro desde donde estás hoy.',
  icon: AlertTriangleIcon
}, {
  title: 'Siempre los mismos básicos',
  desc: 'No sabés cómo progresar hacia las estaciones funcionales reales.',
  icon: DumbbellIcon
}, {
  title: 'Tu cuerpo no responde igual',
  desc: 'Volviste al entrenamiento pero no ves ni sentís avance concreto.',
  icon: BatteryWarningIcon
}, {
  title: 'Tips sueltos de Instagram',
  desc: 'Sin un método claro que respalde tu entrenamiento semana a semana.',
  icon: SmartphoneIcon
}, {
  title: 'No sabés cómo organizarte',
  desc: 'Trabajo, familia y entrenamiento no encuentran el equilibrio.',
  icon: CalendarXIcon
}, {
  title: 'Fin de mes sin progreso real',
  desc: 'Sin estructura progresiva, el esfuerzo no se convierte en resultado.',
  icon: TrendingDownIcon
}];
export function PainPoints() {
  return <section className="py-24 px-4 bg-brand-black" data-id="element-170">
      <div className="max-w-5xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-172">
          <h2 className="text-4xl md:text-6xl text-white mb-4" data-id="element-173">
            ¿TE PASA <span className="text-brand-pink" data-id="element-174">ESTO?</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-175">
            Si querés entrenar para HYROX en Argentina, esto te suena familiar:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-16" data-id="element-176">
          {painPoints.map((pt, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex gap-4 bg-brand-dark p-6 rounded-xl border border-gray-800/50" data-id="element-177">
              <div className="flex-shrink-0 mt-1" data-id="element-178">
                <pt.icon className="w-6 h-6 text-brand-pink/80" data-id="element-179" />
              </div>
              <div data-id="element-180">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-181">
                  {pt.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-182">
                  {pt.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-183">
          <p className="text-2xl md:text-3xl text-white font-display tracking-wide" data-id="element-184">
            ¿Cuántas semanas más vas a entrenar sin un sistema diseñado para tu
            vida real?
          </p>
        </motion.div>
      </div>
    </section>;
}